import React from 'react';
import { Elements } from '@kontent-ai/delivery-sdk';
import { PortableTextComponents } from '@portabletext/react';
import RichTextBody from './RichTextBody';

interface BodyProps {
  element: Elements.RichTextElement;
  resolver?: (
    element: Elements.RichTextElement,
  ) => Partial<PortableTextComponents>;
}

const Body: React.FC<BodyProps> = ({ element, resolver: _resolver }) => {
  // if (!element || !element.value || element.value === '<p><br></p>') {
  //   return null;
  // }

  return (
    <div>
      <RichTextBody element={element} isInsideTable={false} />
    </div>
  );
};

export default Body;
